<template>
  <div>
    <label class="field-label" :for="question.questionId">{{ question.label }}</label>
    <p class="field-value">{{ question.description }}</p>
    <div v-if="isCollection" :id="question.questionId" data-test="multi-field">
      <div v-if="value.length === 0" class="field-value">
        <span v-if="emptyValuePlaceholder">{{emptyValuePlaceholder}}</span>
        <span v-else>No {{question.label || decamelize(question.questionId)}}</span>
      </div>
      <DynamicLayoutWrapper
        v-for="(elValue, index) of value"
        :key="index"
        :document-value="documentValue"
        :value="elValue"
        :template="template"
        :questions="questionsArray"
        :columns="columns"
        :path="[ ...path, question.dataKey, index ]"
        class="mb-4 p-3 border rounded-md"
        :data-index="index"
      />
    </div>
    <div v-else :id="question.questionId">
      <DynamicLayoutWrapper
        :document-value="documentValue"
        :value="value"
        :template="template"
        :questions="questionsArray"
        :columns="columns"
        :path="[ ...path, question.dataKey ]"
        class="mb-4 p-3 border rounded-md"
        data-test="multi-field"
      />
    </div>
  </div>
</template>

<script>
import DynamicLayoutWrapper from '../DynamicLayoutWrapper'
import { decamelize } from '@/utils/generalUtils'

export default {
  components: { DynamicLayoutWrapper },
  props: {
    value: {
      type: [Array, Object],
      default: () => ({}),
    },
    question: {
      type: Object,
      required: true,
    },
    questions: {
      type: Object,
      required: true,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    documentValue: {
      type: Object,
      required: true,
    },
    path: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isCollection() {
      return Array.isArray(this.value)
    },
    questionsArray() {
      return Object.values(this.questions)
    },
    template() {
      return (
        this.question?.config?.template ||
        this.questionsArray
          .map((q) => ({
            id: q.questionId || q.dataKey || q.key,
            type: 'question',
            hidden: q.hidden,
          }))
          .filter((el) => !el.hidden)
      )
    },
    columns() {
      if (this.question?.config?.template) return 'auto'
      return 2
    },
    emptyValuePlaceholder() {
      return this.question?.config?.emptyValuePlaceholder
    },
  },
  methods: {
    decamelize,
  },
}
</script>
